import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import SurveyStatusLabel from 'components/SurveyStatusLabel'

import { ContentContainer } from 'components/ContentContainer'
import Routes from './Routes'
import PageHeaderContainer from 'shared/components/PageHeader/container'
import { truncateTextByCharacters } from 'libs/text'

class Admin extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Routes />
      </React.Fragment>
    )
  }
}

Admin.propTypes = {
  location: PropTypes.object,
}

export default withRouter(Admin)

/**
 * @param {object} props
 * @param {React.ReactElement} props.children
 */
export const AdminContainer = ({ children }) => <ContentContainer>{children}</ContentContainer>

/**
 * @param {object} props
 * @param {React.ReactElement} props.children
 * @param {string} props.pageHeaderName
 * @param {object} props.survey
 * @param {object} props.isOngoingEmailLive
 */

export const AdminHeader = ({ children, pageHeaderName, survey, isOngoingEmailLive }) => {
  const truncatedHeaderName = truncateTextByCharacters(pageHeaderName, 50)

  return (
    <PageHeaderContainer
      title={truncatedHeaderName}
      leftSlot={
        <SurveyStatusLabel
          className="ml2"
          survey={survey}
          isOngoingEmailLive={isOngoingEmailLive}
        />
      }
      rightSlot={<div>{children}</div>}
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/index.js